import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_GATEWAY_PATH, Cms, ICarDetails, IGetCarDetailsResponse } from '@impact/data';
import { BehaviorSubject, Observable } from 'rxjs';

import { SettingsService } from '../core/settings.service';

@Injectable({
    providedIn: 'root',
})
export class CarDetailsService {
    private globalSettings: Cms.SettingsDto;

    private visitedCarPageId$ = new BehaviorSubject<number | undefined>(undefined);
    private visitedFilterPageYPos$ = new BehaviorSubject<number>(0);
    private currentCarMakeModel$ = new BehaviorSubject<any>(undefined);

    constructor(private http: HttpClient, private settingsService: SettingsService) {
        this.settingsService.get().subscribe((settings) => (this.globalSettings = settings));
    }

    public setCurrentMakeAndModel(make: string | null | undefined, model: string | null | undefined, id?: number) {
        this.currentCarMakeModel$.next({
            make,
            model,
            id
        });
    }

    getCurrentMakeAndModel(): Observable<any> {
        return this.currentCarMakeModel$;
    }

    public fetchCarDetailsForId(id: string) {
        return this.http.get<IGetCarDetailsResponse>(`/${API_GATEWAY_PATH}/filter/GetCarDetail`, {
            params: {
                id,
            },
        });
    }

    public generateUrl(usedCar: ICarDetails): string[] {
        return [
            `${this.globalSettings?.globalPages?.usedCarsOverviewPage?.url}/${usedCar.id}`.toLowerCase(),
            `${this.globalSettings?.globalPages?.b2bUsedCarsOverviewPage?.url}/${usedCar.id}`.toLowerCase(),
        ];
    }

    setVisitedCarId(carId: number | undefined) {
        this.visitedCarPageId$.next(carId);
    }

    getVisitedCarId(): Observable<number | undefined> {
        return this.visitedCarPageId$.asObservable();
    }

    setVisitedFilterPageYPos(yPos: number) {
        this.visitedFilterPageYPos$.next(yPos);
    }

    getVisitedFilterPageYPos(): Observable<number> {
        return this.visitedFilterPageYPos$.asObservable();
    }
}
